<template>
  <div class="page-wrapper">
    <section class="integral-banner">
      <img src="@/assets/images/national-day/banner.jpg" alt="" class="banner-img">
    </section>
    <section class="integral-introduce">
      <img src="@/assets/images/national-day/img1.jpg" alt="" class="introduce-img">
    </section>
    <section class="integral-task">
      <ul class="task-box">
        <li
          v-for="(item, index) in clickName"
          :key="index"
          class="task-item"
        >
          <span @click="clickItem(item)" class="task-btn"></span>
        </li>
      </ul>
    </section>
    <section class="integral-rule">
      <img src="@/assets/images/national-day/img3.jpg" alt="" class="rule-img">
    </section>
  </div>
</template>

<script>
import { Toast } from 'vant'

export default {
  name: 'index',
  data() {
    return {
      // activity://go-signin      签到
      // activity://go-lottery     抽奖
      // activity://go-post        发帖
      // activity://go-zxcar       浏览直销商城
      // activity://go-bindcar     绑定车辆
      // activity://go-register    推荐注册
      clickName: ['activity://go-signin', 'activity://go-lottery', 'activity://go-post', 'activity://go-zxcar', 'activity://go-bindcar', 'activity://go-register'],
      version: null,
      isAndroid: false,
      isIOS: false
    }
  },
  created() {},
  mounted() {
    const { version } = this.$route.query
    this.version = version
    const u = navigator.userAgent
    this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  },
  methods: {
    clickItem(item) {
      if (this.isIOS || this.version) {
        document.location = item
      } else {
        Toast('请将APP升级至最新版本参与活动')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.integral-banner {
  height: rem(743);
  .banner-img {
    width: 100%;
    height: 100%;
  }
}
.integral-introduce {
  height: rem(383);
  .introduce-img {
    width: 100%;
    height: 100%;
  }
}
.integral-task {
  height: rem(931);
  background: url('../../assets/images/national-day/img2.jpg') no-repeat;
  background-size: cover;
  overflow: hidden;
  .task-box {
    margin: rem(122) rem(52);
    .task-item {
      display: flex;
      justify-content: flex-end;
      width: rem(644);
      height: rem(122);
      background-size: contain;
      background-repeat: no-repeat;
      margin-bottom: rem(10);
      &:nth-child(1) {
        background-image: url('../../assets/images/national-day/item1.png');
      }
      &:nth-child(2) {
        background-image: url('../../assets/images/national-day/item2.png');
      }
      &:nth-child(3) {
        background-image: url('../../assets/images/national-day/item3.png');
      }
      &:nth-child(4) {
        background-image: url('../../assets/images/national-day/item4.png');
      }
      &:nth-child(5) {
        background-image: url('../../assets/images/national-day/item5.png');
      }
      &:nth-child(6) {
        background-image: url('../../assets/images/national-day/item6.png');
      }
      .task-btn {
        width: rem(116);
        height: 100%;
        border-radius: rem(18);
      }
    }
  }
}
.integral-rule {
  height: rem(495);
  .rule-img {
    width: 100%;
    height: 100%;
  }
}
</style>
